import { IInventoryItem } from "../../types/shoppingList";
import { deleteApi, getApi, postApi } from "../api";
import { InventoryDb } from "../indexeddb/inventoryDb";
import { getStringFromLocalStorage } from "../localStorage";

const apiUrl = import.meta.env.VITE_API_URL as string;
const apiToken = getStringFromLocalStorage("idToken");

export class InventoryStore {
  private static instance: InventoryStore | null = null;
  private _readyPromise: Promise<void>;
  private db = new InventoryDb();
  public inventory: IInventoryItem[] = [];
  private constructor() {
    this._readyPromise = this.load();
  }

  public static getInstance(): InventoryStore {
    if (!InventoryStore.instance) {
      InventoryStore.instance = new InventoryStore();
    }
    return InventoryStore.instance;
  }

  public ready(): Promise<void> {
    return this._readyPromise;
  }

  private async load(): Promise<void> {
    await this.db.initDB();
  }

  public async getInventory(clear: boolean = false): Promise<void> {
    try {
      const local = await this.db.getInventory();
      if (local.length == 0 || clear) {
        const api = await getApi(apiUrl, "inventory", apiToken);
        await this.db.addInventory(api, clear);
        this.inventory = api;
      } else {
        this.inventory = local;
      }
    } catch (e: any) {
      console.log(e);
    }
  }

  public async addToInventory(item: IInventoryItem): Promise<void> {
    try {
      await postApi(apiUrl, "inventory", item, apiToken);
      await this.db.addToInventory(item);
      this.inventory.push(item);
    } catch (e: any) {
      console.log(e);
    }
  }

  public async removeFromInventory(item: IInventoryItem): Promise<void> {
    try {
      await deleteApi(apiUrl, "inventory", undefined, apiToken, {ingredient_name: item.ingredient_name});
      await this.db.removeFromInventory(item);
      this.inventory = this.inventory.filter((i) => i.ingredient_name !== item.ingredient_name);
    } catch (e: any) {
      console.log(e);
    }
  }

  public async clearInventory(): Promise<void> {
    try {
      await deleteApi(apiUrl, "inventory", undefined, apiToken);
      await this.db.clearInventory();
      this.inventory = [];
    } catch (e: any) {
      console.log(e);
    }
  }
}
